import PropTypes from "prop-types";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import SoftTypography from "components/SoftTypography";
import { figmaTokens } from "assets/theme/designTokens";

const DEFAULT_PAGE_SIZES = [10, 20, 50];

function TablePaginationBar({
  page,
  totalCount,
  pageSize,
  pageSizeOptions = DEFAULT_PAGE_SIZES,
  onPageChange,
  onPageSizeChange,
  totalPages = null,
  pageSizeLabel,
}) {
  if (totalCount <= 0) return null;

  const pages = totalPages ?? 1;
  const showPagination = pages > 1;

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      alignItems={{ xs: "stretch", sm: "center" }}
      justifyContent="space-between"
      spacing={2}
      sx={{ py: 2.5, px: { xs: 1.5, md: 2 }, borderTop: `1px solid ${figmaTokens.cardHeaderRule}` }}
    >
      <Stack direction="row" alignItems="center" spacing={1.25} flexShrink={0}>
        <SoftTypography variant="caption" sx={{ fontWeight: 600, color: figmaTokens.textMuted }}>
          {pageSizeLabel}
        </SoftTypography>
        <FormControl size="small">
          <Select
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            sx={{
              minWidth: 76,
              fontSize: "0.875rem",
              borderRadius: "10px",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: figmaTokens.borderSubtle,
              },
            }}
          >
            {pageSizeOptions.map((n) => (
              <MenuItem key={n} value={n}>
                {n}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
      {showPagination ? (
        <Pagination
          count={pages}
          page={page}
          onChange={(_, value) => onPageChange(value)}
          color="primary"
          shape="rounded"
          sx={{ alignSelf: { xs: "center", sm: "flex-end" } }}
        />
      ) : null}
    </Stack>
  );
}

TablePaginationBar.propTypes = {
  page: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  onPageChange: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
  totalPages: PropTypes.number,
  pageSizeLabel: PropTypes.string.isRequired,
};

export default TablePaginationBar;
